import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { createSelector } from "reselect";

const slice = createSlice({
  name: "operations",
  initialState: {
    list: [],
    operationSelected: [],
    prospectCreateFailed: false,
    prospectCreating: false,
    isProspectCreated: false,
    prospectid: null,
  },
  reducers: {
    resetOperations: (operations, action) => {
      operations.prospectid = null;
      operations.isProspectCreated = false;
    },
    operationsReceived: (operations, action) => {
      operations.list = action.payload;
    },
    operationSelected: (operations, action) => {
      operations.operationSelected = action.payload;
    },
    prospectCreateInitialized: (operations, action) => {
      operations.prospectCreating = true;
    },

    prospectCreateFailed: (operations, action) => {
      operations.prospectCreateFailed = true;
      operations.prospectCreating = false;
    },

    prospectCreateSuccess: (operations, action) => {
      operations.prospectCreateFailed = false;
      operations.prospectCreating = false;
      operations.isProspectCreated = true;
      operations.prospectid = action.payload.prospectid;
    },
  },
});

export const {
  operationsReceived,
  operationSelected,
  prospectCreateInitialized,
  prospectCreateFailed,
  prospectCreateSuccess,
  resetOperations
} = slice.actions;

export default slice.reducer;

// action creator
export const loadOperations = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/operations?brokeragecode=" + data,
    method: "get",
    data: data,
    onSuccess: operationsReceived.type,
  });

export const createProspectByCallingAPI = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/prospects/add",
    method: "post",
    data: data,
    onStart: prospectCreateInitialized.type,
    onSuccess: prospectCreateSuccess.type,
    onError: prospectCreateFailed.type,
  });

// Selector

export const getOperationsList = createSelector(
  (state) => state.entities.operations,
  (operations) => operations.list
);

export const getOperationsSelected = createSelector(
  (state) => state.entities.operations,
  (operations) => operations.operationSelected
);

export const getProspectIdJustCreated = createSelector(
  (state) => state.entities.operations,
  (operations) => operations.prospectid
);

export const getProspectCreating = createSelector(
  (state) => state.entities.operations,
  (operations) => operations.prospectCreating
);
